import type {SidebarFooterProps} from "@toolpad/core/DashboardLayout";
import {alpha, Box, Button, Chip, IconButton, Stack, Tooltip, useTheme} from "@mui/material";
import {BugReport, WebAsset} from "@mui/icons-material";
import AD3 from "@/components/GoogleAds/ad3";
import Link from "next/link";
import React from "react";
import { ThemeSwitcher } from "@/components/ThemeProvider/ThemeSwitcher";

export const SidebarFooter = ({mini}: SidebarFooterProps) => {
	const theme = useTheme();
	const issueLink = `/bug-report`;
	const blogLink = `/blogs`;
	const msg = `Hi, I was on ${process.env.NEXT_PUBLIC_SITE_URL} and I need help with...`;
	// const link = "https://web.whatsapp.com/send?phone=917607537338&text=" + encodeURIComponent(msg);
	const whatsappLink = "https://wa.me/917607537338?text=" + encodeURIComponent(msg);
	const buildNumber = process.env.NEXT_PUBLIC_BUILD_NUMBER;
	const environment = process.env.NEXT_PUBLIC_ENVIRONMENT;
	if (mini)
		return (
			<Box
				sx={{
					p: 2,
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					borderTop: 1,
					borderColor: "divider",
					zIndex: 3,
				}}
			>
				{/*<IconButton
					href={whatsappLink}
					target="_blank"
					rel="noopener noreferrer"
					color="success"
				>
					<WhatsApp />
				</IconButton>*/}
				{/* <Tooltip title="Toggle Theme" arrow>
					<ThemeSwitcher />
				</Tooltip> */}

				<Tooltip title="Report Issue" arrow>
					<IconButton component={Link} href={issueLink} color="warning">
						<BugReport />
						<span
							style={{
								position: "absolute",
								width: "1px",
								height: "1px",
								padding: "0",
								margin: "-1px",
								overflow: "hidden",
								clip: "rect(0, 0, 0, 0)",
								whiteSpace: "nowrap",
								borderWidth: "0",
							}}
						>
							Report Issue
						</span>
					</IconButton>
				</Tooltip>

				<Tooltip title="Go to Jobstacky Blog" arrow>
					<IconButton
						component={Link}
						href={blogLink}
						target="_blank"
						rel="noopener noreferrer"
						color="success"
					>
						<WebAsset />
						<span
							style={{
								position: "absolute",
								width: "1px",
								height: "1px",
								padding: "0",
								margin: "-1px",
								overflow: "hidden",
								clip: "rect(0, 0, 0, 0)",
								whiteSpace: "nowrap",
								borderWidth: "0",
							}}
						>
							Go to Jobstacky Blog
						</span>
					</IconButton>
				</Tooltip>
			</Box>
		);
	else
		return (
			<>
				{/*<AD3 />*/}
				<Box
					sx={{
						p: 2,
						pb: 0.5,
						borderTop: 1,
						borderColor: "divider",
						position: "sticky",
						bottom: 0,
						zIndex: 3,
						display: "flex",
						flexDirection: "column",
						gap: 0.5,
					}}
				>
					<Stack spacing={1}>
						{/* <Box
							sx={{
								display: "flex",
								justifyContent: "center",
								mb: 1,
							}}
						>
							<Tooltip title="Toggle Theme" arrow>
								<ThemeSwitcher />
							</Tooltip>
						</Box> */}
						{/*<Button
							fullWidth
							variant="outlined"
							color="success"
							startIcon={<WhatsApp />}
							href={whatsappLink}
							target="_blank"
							rel="noopener noreferrer"
						>
							WhatsApp Us
						</Button> */}
						<Button
							fullWidth
							component={Link}
							variant="outlined"
							color="primary"
							sx={{
								bgcolor: alpha(theme.palette.primary.main, 0.08),
								"&:hover": {
									bgcolor: alpha(theme.palette.primary.main, 0.15),
								},
							}}
							startIcon={<BugReport />}
							href={issueLink}
						>
							Report an issue
						</Button>
						<Button
							fullWidth
							component={Link}
							variant="outlined"
							color="primary"
							sx={{
								bgcolor: alpha(theme.palette.primary.main, 0.08),
								"&:hover": {
									bgcolor: alpha(theme.palette.primary.main, 0.15),
								},
							}}
							startIcon={<WebAsset />}
							href={blogLink}
							target="_blank"
							rel="noopener noreferrer"
						>
							Jobstacky Blog
						</Button>
					</Stack>
					<Chip
						label={buildNumber ? `${buildNumber} - ${environment}` : "Local"}
						color="default"
						sx={{
							height: "fit-content",
							width: "fit-content",
							mx: "auto",
							fontSize: "10px",
						}}
					/>
				</Box>
			</>
		);
};
